import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SetdataContext } from "../context/SetdataContext";

function Login() {
    const navigate = useNavigate()

    const {login} = useContext(SetdataContext)

    const [userData, setUserData] = useState({user: "", pass: "", link: ""})

    const onchangeData = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value 
        })
        console.log(userData);
    }

    const submit = (e) => {
        e.preventDefault()
        let valid = login(userData)
        console.log(valid);
        if(valid){
            navigate("/" + userData.link)
        }
    }
    return(
        <div className="login">
            <div className="login__div">
                <form className="login__form" onSubmit={submit}>
                    <label htmlFor="user">USUARIO: </label>
                    <input type="text" name="user" id="user" onChange={onchangeData}/>

                    <label htmlFor="pass">PASSWORD: </label>
                    <input type="password" name="pass" id="pass" onChange={onchangeData}/>
                    
                    <label htmlFor="link">destino</label>
                    <input type="text" name="link" id="link" onChange={onchangeData}/>

                    <button type="submit">ENTRAR</button>
                </form>
            </div>
        </div>
    )
}

export default Login